import { Data } from '@/modules/shared/models/data'

export enum BillingInfoType {
  LEGAL = 'legal',
  NATURAL = 'natural'
}

export enum PersianPersonTitle {
  LEGAL = 'حقوقی',
  NATURAL = 'حقیقی'
}

export interface BillingInfoResourceModel {
  id: number
  type: BillingInfoType
  natural_name: string | null
  natural_melli_code: number | null
  natural_tell: number | null
  natural_address: string | null
  natural_zip_code: number | null
  legal_name: string | null
  legal_national_code: number | null
  legal_financial_code: number | null
  legal_registry_code: number | null
  legal_address: string | null
  legal_zip_code: number | null
  legal_tell: number | null
}

export interface BillingInfoSwitchResourceModelLegal {
  type: BillingInfoType.LEGAL
  legal_name: string
  legal_financial_code: number | string
  legal_registry_code: number | string
  legal_national_code: number | string
  legal_address: string
  legal_zip_code: number | string
  legal_tell: number | string
}

export interface BillingInfoSwitchResourceModelNatural {
  type: BillingInfoType.NATURAL
  natural_name: string
  natural_melli_code: number | string
  natural_tell: number | string
  natural_address: string
  natural_zip_code: number | string
}

export type BillingInfoSwitchResourceModel = {
  id: number,
  persian_title: PersianPersonTitle,
} & (BillingInfoSwitchResourceModelLegal | BillingInfoSwitchResourceModelNatural)

export interface BillingInfoResourceWithModel {
  types: { [key in BillingInfoType]: string }
}

export type BillingInfoResourceType = Data<BillingInfoResourceModel> & BillingInfoResourceWithModel
